// extracted by mini-css-extract-plugin
export default {"spin":"preloader_spin__Iq7CW","preloader":"preloader_preloader__33tiq"};